// extracted by mini-css-extract-plugin
module.exports = {"resourceList":"style__resourceList__O7-A3"};